import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import * as api from "../constant/API";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";

const Header = () => {
  const routes = all_routes;
  const location = useLocation();
  const userName = localStorage.getItem('FullName');
  const roleId = localStorage.getItem('RoleId');
  let roleType = '';

  const [menuList, setMenuList] = useState([]);
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  useEffect(() => {
    // getmenuList()
    const token = Utils.getAccessToken();
    const roleId = localStorage.getItem("RoleId"); // Or any other auth flag

    if (token && roleId) {
      getmenuList();
    }
  }, [])

  function getmenuList() {
    const menuGet = api.MenuList + '/' + roleId;
    fetch(menuGet, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": 'Bearer ' + Utils.getAccessToken()
      }
    })
      .then((menuResponse) => menuResponse.json())
      .then((menuResult) => {
        // console.log(menuResult)
        if (menuResult.error == true) {
          if (menuResult.code == 401) {
            Utils.logoutUser();
          }
          Swal.fire(menuResult.message)
        }
        else {
          // setMenuList(menuResult.data)
          processMenuList(menuResult.data);
        }
      })
  }

  const processMenuList = (menuData: any[]) => {
    const organizedMenu: any = {};

    menuData.forEach((menuItem) => {
      const section = menuItem.menuSection;

      if (!organizedMenu[section]) {
        organizedMenu[section] = {
          menuSection: section,
          menu: [],
        };
      }

      organizedMenu[section].menu.push({
        menuIcon: menuItem.menuIcon,
        menuName: menuItem.menuName,
        menuPath: menuItem.menuPath.replace(/\//g, ""), // Clean path
        rbacMenuAccess: menuItem.rbacMenuAccess,
        menuStatus: menuItem.menuStatus,
      });
    });

    // Convert to array format
    // setMenuList(Object.values(organizedMenu));

    let resultArray = Object.values(organizedMenu);

    // Apply role-based filtering
    resultArray = resultArray.filter((section: any) => {
      if (section.menuSection === "LMS" || section.menuSection === "Main") return false;
      // if (section.menuSection === "Samsara" && roleId === "6") return false;
      return true;
    });

    resultArray.forEach((section: any) => {
      if (section.menuSection === "Institute") {
        section.menuSection = "Institute Specific";
        section.menu = section.menu.filter((menuItem: any) => menuItem.rbacMenuAccess === '1');
      }
      section.menu = section.menu.filter(
        (menuItem: any) =>
          menuItem.rbacMenuAccess !== 0 &&
          menuItem.menuStatus !== 0 &&
          !(
            // roleId === "6" &&
            // (
            //   menuItem.menuName === "Billing & Payment" ||
            //   menuItem.menuName === "Analytics" ||
            //   menuItem.menuName === "Users"
            // )
            (["5", "6", "7", "8"].includes(roleId) &&
              (menuItem.menuName === "Billing & Payment" ||
                menuItem.menuName === "Analytics")) ||

            // hide Users only for role 6
            (["6", "7", "8"].includes(roleId) && menuItem.menuName === "Users") ||
            ((roleId === "7" || roleId === "8") && menuItem.menuName === "Academics") ||
            (roleId === "8" && (menuItem.menuName === "Institutes" || menuItem.menuName === "Inventory" || menuItem.menuName === "Reports"))
      )
      );
  });
  resultArray.sort((a: any, b: any) => a.menuSection.localeCompare(b.menuSection));

  setMenuList(resultArray);
};

const toggleMenu = (state: "open" | "close") => {
  document.documentElement.classList.toggle("menu-opened", state === "open");
};
const toggleSubMenu = (index: number) => {
  setActiveSubMenu(activeSubMenu === index ? null : index);
};

if (roleId == "8") {
  roleType = '/auth/tenvic-student';
} else if (roleId == "7") {
  roleType = '/auth/tenvic-institution';
} else {
  roleType = '/auth/tenvic-login';
}

const header = [
  {
    tittle: "Dashboard",
    showAsTab: false,
    separateRoute: true,
    // routes: routes.home,
    hasSubRoute: false,
    showSubRoute: false,
  },
  {
    tittle: "General",
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: "Institutes",
        routes: routes.general,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
      {
        menuValue: "Sports",
        routes: routes.sports,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
      {
        menuValue: "Inventory",
        routes: routes.inventory,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
      {
        menuValue: "Video & Documents",
        routes: routes.tutorial,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
      ...(roleId === "1"
        ? [
          {
            menuValue: "Academics",
            routes: routes.academic,  // Make sure routes.academics exists
            hasSubRoute: false,
            showSubRoute: false,
            subMenus: [],
          },
        ]
        : []),
      {
        menuValue: "Reports",
        routes: routes.reports,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
      ...(roleId === "1"
        ? [
          {
            menuValue: "Analytics",
            routes: routes.analytics,  // Make sure routes.academics exists
            hasSubRoute: false,
            showSubRoute: false,
            subMenus: [],
          },
        ]
        : []),
    ]
  },
  {
    tittle: "Institiute Specific",
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: "Students",
        routes: routes.institutespecific,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
      {
        menuValue: "Batches",
        routes: routes.batches,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
      {
        menuValue: "Schedules",
        routes: routes.schedules,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
      {
        menuValue: "Attendance",
        routes: routes.attendance,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
      {
        menuValue: "Assessment",
        routes: routes.assessment,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
    ]
  },
  {
    tittle: "Support",
    showAsTab: false,
    separateRoute: true,
    routes: routes.support,
    hasSubRoute: false,
    showSubRoute: false,
  },
];

const customStyle = {
  background: location.pathname.includes(routes.home)
    ? "rgb(255,255,255)" // "rgb(15, 42, 78)"
    : "#ffffff",
};

return (
  <header
    className={
      location.pathname.includes(routes.home)
        ? "header header-trans"
        : "header header-sticky"
    }
    style={customStyle}
  >
    <div className="container-fluid">
      <nav className="navbar navbar-expand-lg header-nav">
        <div className="navbar-header">
          <Link id="mobile_btn" to="#" onClick={() => toggleMenu('open')}>
            <span className="bar-icon">
              <span />
              <span />
              <span />
            </span>
          </Link>
          <Link to="institution" className="navbar-brand logo">
            {/* <ImageWithBasePath src="assets/img/logo.svg" className="img-fluid" alt="Logo" /> */}

            {location.pathname.includes(routes.home) ? (
              <ImageWithBasePath
                src="assets/img/Tenvic/TENVICLogo.png"
                className="img-fluid"
                alt="Logo"
              />
            ) : (
              <ImageWithBasePath
                src="assets/img/Tenvic/TENVICLogo.png"
                className="img-fluid"
                alt="Another Image"
              />
            )}
          </Link>
        </div>
        <div className="main-menu-wrapper">
          <div className="menu-header">
            <Link to="institution" className="menu-logo">
              {location.pathname.includes(routes.home) ? (
                <ImageWithBasePath
                  src="assets/img/Tenvic/TENVICLogo.png"
                  className="img-fluid"
                  alt="Logo"
                />
              ) : (
                <ImageWithBasePath
                  src="assets/img/Tenvic/TENVICLogo.png"
                  className="img-fluid"
                  alt="Another Image"
                />
              )}
            </Link>
            <Link id="menu_close" className="menu-close" to="#" onClick={() => toggleMenu('close')}>
              <i className="fas fa-times" />
            </Link>
          </div>
          <ul className="main-nav">
            {menuList.map((mainMenus, mainIndex) => (
              <React.Fragment key={mainIndex}>
                {/* {mainMenus.separateRoute ? (
                    <li
                      key={mainIndex}
                      className={
                        location.pathname.includes(mainMenus.routes)
                          ? "active"
                          : ""
                      }
                    >
                      <Link to={mainMenus.routes}>{mainMenus.tittle}</Link>
                    </li>
                  ) : (
                    <li
                      className={`has-submenu ${mainMenus?.menu?.map((item) => item?.routes).includes(location.pathname) ? "active" : ""}`}
                    >
                      <Link to="#">
                        {mainMenus.tittle}{" "}
                        <i className="fas fa-chevron-down"></i>
                      </Link>
                      <ul
                        className={`submenu ${mainMenus.showAsTab ? "d-block" : ""}`}
                      >
                        {mainMenus.menu?.map((menu, menuIndex) => (
                          <li
                            key={menuIndex}
                            className={`${menu.hasSubRoute ? "has-submenu" : ""} ${menu?.subMenus?.map((item) => item?.routes).includes(location.pathname) ? "active" : ""}`}
                          >
                            {menu.hasSubRoute ? (
                              <React.Fragment>
                                <Link to="#">{menu.menuValue}</Link>
                                <ul
                                  className={`submenu ${menu.showSubRoute ? "d-block" : ""}`}
                                >
                                  {menu.subMenus?.map(
                                    (subMenu, subMenuIndex) => (
                                      <li key={subMenuIndex}>
                                        <Link to={subMenu.routes}>
                                          {subMenu.menuValue}
                                        </Link>
                                      </li>
                                    )
                                  )}
                                </ul>
                              </React.Fragment>
                            ) : (
                              <li
                                className={
                                  location.pathname.includes(menu.routes)
                                    ? "active"
                                    : ""
                                }
                              >
                                <Link to={menu.routes}>{menu.menuValue}</Link>
                              </li>
                            )}
                          </li>
                        ))}
                      </ul>
                    </li>
                  )} */}
                <li className={`has-submenu ${activeSubMenu === mainIndex ? "open" : ""}`}>
                  <Link to="#" onClick={() => toggleSubMenu(mainIndex)}>
                    {mainMenus.menuSection} <i className="fas fa-chevron-down"></i>
                  </Link>
                  <ul className={`submenu ${activeSubMenu === mainIndex ? "d-block" : "d-none"}`}
                  // style={{
                  //   maxHeight: "300px", // Set the maximum height
                  //   overflowY: "auto", // Enable vertical scrolling
                  //   scrollbarWidth: "thin", // For Firefox
                  //   scrollbarColor: "#ccc #f1f1f1", // For Firefox
                  // }}
                  >
                    {mainMenus.menu.map((menuItem, menuIndex) => (
                      <li key={menuIndex}>
                        <Link to={menuItem.menuPath.replace(/\//g, "")} onClick={() => toggleMenu('close')}
                        >
                          <i className={menuItem.menuIcon}></i> {menuItem.menuName}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              </React.Fragment>
            ))}
          </ul>
        </div>
        <ul className="nav header-navbar-rht">
          <li className="nav-item dropdown">
            <div className="avatar">
              <Link
                to="#"
                className="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <ImageWithBasePath src="assets/img/Tenvic/user.png" className="avatar-img rounded-circle" width="45px" />
                <span className="fw-semibold fs-16">{userName}</span>
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
                Welcome!
                <Link
                  className="dropdown-item"
                  to="/profile"
                >
                  <i className="fas fa-user"></i>
                  <span>My Profile</span>
                </Link>
                <Link
                  className="dropdown-item"
                  to="#"
                >
                  <i className="fas fa-chart-pie"></i>
                  <span>Performance</span>
                </Link>
                <Link
                  className="dropdown-item"
                  onClick={() => {
                    localStorage.clear();
                    // console.log("localstorage", { ...localStorage })
                  }}
                  // to = "/auth/tenvic-login"
                  to={roleType}
                >
                  <i className="fas fa-person-running"></i>
                  <span>Logout</span>
                </Link>
              </div>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </header>
  //   <header
  //   className={location.pathname.includes("/home") ? "header header-trans" : "header header-sticky"}
  // >
  // <header
  //   className={
  //     location.pathname.includes(routes.home)
  //       ? "header header-trans"
  //       : "header header-sticky"
  //   }
  //   style={customStyle}
  // >
  //   <div className="container-fluid">
  //     <nav className="navbar navbar-expand-lg header-nav">
  //       <div className="navbar-header">
  //         <Link id="mobile_btn" to="#" onClick={() => toggleMenu('open')}>
  //           <span className="bar-icon">
  //             <span />
  //             <span />
  //             <span />
  //           </span>
  //         </Link>
  //         <Link to="/" className="navbar-brand logo">
  //           <img src="assets/img/Tenvic/TENVICLogo.png" className="img-fluid" alt="Logo" />
  //         </Link>
  //       </div>
  //       <div className="main-menu-wrapper">
  //         <ul className="main-nav">
  //           {menuList.map((section, index) => (
  //             <li key={index} className={`has-submenu ${activeSubMenu === index ? "open" : ""}`}>
  //               <Link to="#" onClick={() => toggleSubMenu(index)}>
  //                 {section.menuSection} <i className="fas fa-chevron-down"></i>
  //               </Link>
  //               <ul className={`submenu ${activeSubMenu === index ? "d-block" : "d-none"}`}>
  //                 {section.menu.map((menuItem: any, menuIndex: number) => (
  //                   <li key={menuIndex}>
  //                     <Link to={menuItem.menuPath.replace(/\//g, "")}>
  //                       <i className={menuItem.menuIcon}></i> {menuItem.menuName}
  //                     </Link>
  //                   </li>
  //                 ))}
  //               </ul>
  //             </li>
  //           ))}
  //         </ul>
  //       </div>
  //       <ul className="nav header-navbar-rht">
  //         <li className="nav-item dropdown">
  //           <div className="avatar">
  //             <Link to="#" className="action-icon dropdown-toggle" data-bs-toggle="dropdown">
  //               <img src="assets/img/Tenvic/user.png" className="avatar-img rounded-circle" width="45px" />
  //               <span className="fw-semibold fs-16">{userName}</span>
  //             </Link>
  //             <div className="dropdown-menu dropdown-menu-end">
  //               <Link className="dropdown-item" to="#">
  //                 <i className="fas fa-user"></i> <span>My Profile</span>
  //               </Link>
  //               <Link className="dropdown-item" to="#">
  //                 <i className="fas fa-chart-pie"></i> <span>Performance</span>
  //               </Link>
  //               <Link
  //                 className="dropdown-item"
  //                 onClick={() => {
  //                   localStorage.clear();
  //                   window.location.href = roleType;
  //                 }}
  //               >
  //                 <i className="fas fa-person-running"></i> <span>Logout</span>
  //               </Link>
  //             </div>
  //           </div>
  //         </li>
  //       </ul>
  //     </nav>
  //   </div>
  // </header>
);
};

export default Header;
